<template>
  <div class="question-answer-container">
    <!-- Top Navigation Bar -->
    <div class="top-bar">
      <div class="left-icon" @click="goBack">
        <i class="el-icon-back"></i>
      </div>
      <div class="title">{{ title }}</div>
      <div class="right-icons">
        <!-- 可选图标 -->
      </div>
    </div>

    <!-- 客服与热线区域 -->
    <div class="hotline-and-service">
      <span class="service-text" @click="showHotlineDialog">人工热线电话</span>
    </div>

    <div class="customer-service">
      <img src="../assets/icon_robot.png" alt="Customer Service Icon" class="service-icon">
      <span class="service-text">{{ pageTitle }}</span>
    </div>

    <div class="popular-issues">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="热门问题" name="popularQuestions">
          <ul>
            <li v-for="(item, index) in popularQuestions" :key="index" @click="navigateTo(item.id)">
              <i class="el-icon-chat-dot-round"></i>
              <span class="question-title">{{ item.title }}</span>
            </li>
          </ul>
        </el-tab-pane>
        <!-- 动态生成的 tabs -->
        <el-tab-pane
          v-for="type in questionTypes"
          :key="type.enumId"
          :label="type.enumName"
          :name="String(type.enumId)"
        >
          <ul>
            <li v-for="(item, index) in popularQuestions" :key="index" @click="navigateTo(item.id)">
              <i class="el-icon-chat-dot-round"></i>
              <span class="question-title">{{ item.title }}</span>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 弹窗：服务网点电话 -->
    <el-dialog title="各地市服务电话" :visible.sync="dialogVisible" width="90%">
      <el-table :data="hotlines" border style="width: 100%">
        <el-table-column prop="city" label="城市" align="center"></el-table-column>
        <el-table-column label="电话号码" align="center">
          <template slot-scope="{ row }">
            <div v-for="(num, idx) in formatPhoneNumber(row.number)" :key="idx" class="phone-number-item">
              <a :href="`tel:${num}`" >{{ num }}</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <div class="chat-dialog">
      <div v-for="item in dialogList" :key="item.id" :id="`dialog-${item.id}`"
           :class="['dialog-item', { active: item.id === activeId }]">

        <!-- 用户提问 -->
        <div class="user-question">
          {{ item.question }}
        </div>

        <!-- 系统回答 -->
        <div class="bot-answer" v-html="item.answer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      activeTab: 'popularQuestions',
      title: '问一问',
      pageTitle: '您好！我是您的征信小帮手，您可以问我央行征信相关问题哦。',
      hotline: '0591-62623959',
      loading: false,
      popularQuestions: [],
      dialogVisible: false,
      hotlines: [
        {city: '兰州市', number: '0931-8800569'},
        {city: '嘉峪关市', number: '0937-6320014'},
        {city: '金昌市', number: '0935-8610551'},
        {city: '白银市', number: '0943-8269064'},
        {city: '天水市', number: '0938-8274257'},
        {city: '武威市', number: '0935-2262026'},
        {city: '张掖市', number: '0936-8257234'},
        {city: '平凉市', number: '0933-8268134'},
        {city: '酒泉市', number: '0937-2677084'},
        {city: '庆阳市', number: '0934-8628613'},
        {city: '定西市', number: '0932-8226359'},
        {city: '陇南市', number: '0939-8266161'},
        {city: '临夏回族自治州', number: '0930-6241070'},
        {city: '甘南藏族自治州', number: '0941-8250020'}
      ],
      dialogList: [],
      activeId: null,
      questionTypes: [],
      selectedType: '',
      defaultTypeCode: '1017001'
    }
  },
  created() {
    this.fetchPopularQuestions()
    this.fetchQuestionTypes()
  },
  methods: {
    // 将电话号码字符串按 '/' 分割成数组
    formatPhoneNumber(phoneStr) {
      return phoneStr ? phoneStr.split('/').map(num => num.trim()) : []
    },
    handleTabClick(tab) {
      const typeId = tab.name
      console.log(tab.key)
      if (typeId === 'popularQuestions') {
        this.fetchPopularQuestions()
      } else {
        this.fetchTypeQuestions(typeId)
      }
    },
    navigateTo(id) {
      const existed = this.dialogList.find(item => item.id === id)
      if (existed) {
        // 如果已经存在，滚动到该元素
        this.scrollToDialog(id)
      } else {
        // 否则请求接口获取答案
        this.fetchAnswerAndAppend(id)
      }
    },
    scrollToDialog(id) {
      this.activeId = id
      this.$nextTick(() => {
        const el = document.getElementById(`dialog-${id}`)
        if (el) {
          el.scrollIntoView({behavior: 'smooth', block: 'center'})
        }
      })
    },
    async fetchAnswerAndAppend(id) {
      try {
        const res = await axios.get(this.$config.baseUrl + `/appointment-web/questionAnswerController/${id}`)
        const question = this.popularQuestions.find(p => p.id === id)
        this.dialogList.push({
          id,
          question: question?.title || '未知问题',
          answer: res.data.answerText || '暂无答案'
        })
        this.$nextTick(() => {
          this.scrollToDialog(id)
        })
      } catch (err) {
        console.error('获取答案失败:', err)
        this.dialogList.push({
          id,
          question: '未知问题',
          answer: '无法加载此问题的答案。'
        })
      }
    },
    async fetchQuestionTypes() {
      try {
        await axios.get(this.$config.baseUrl + '/appointment-manager/enumController/getEnumList.do?enumTypeId=1017').then(response => {
          this.questionTypes = response.data.data || []
        })
      } catch (err) {
        console.error('获取问题类型失败:', err)
      }
    },
    fetchPopularQuestions() {
      this.loading = true
      axios.get(this.$config.baseUrl + '/appointment-web/questionAnswerController/popular-questions')
        .then(response => {
          this.popularQuestions = response.data || []
        })
        .catch(error => {
          console.error('获取热门问题失败:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchTypeQuestions(questionType) {
      this.loading = true
      axios.post(this.$config.baseUrl + '/appointment-web/questionAnswerController/type-questions', {questionType: questionType})
        .then(response => {
          this.popularQuestions = response.data || []
        })
        .catch(error => {
          console.error('获取热门问题失败:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    goBack() {
      this.$router.go(-1)
    },
    showHotlineDialog() {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.question-answer-container {
  background-color: #EEF7FE;
  height: 100%;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.hotline-and-service {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #ECECEC;
  color: #467AF4;
  cursor: pointer;
}

.service-text {
  color: #467AF4;
  font-weight: bold;
}

.customer-service {
  display: flex;
  align-items: center;
  padding: 10px;
}

.service-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.popular-issues {
  padding: 10px;
  background-color: white;
  border-radius: 10px;
  margin: 10px;
}

.popular-issues ul {
  list-style-type: none;
  padding: 0;
}

.popular-issues li {
  padding: 5px 0;
  cursor: pointer;
}

.question-title {
  color: #467AF4;
}

.popular-issues li:hover {
  color: #467AF4;
}

.chat-dialog {
  padding: 10px;
  border-radius: 10px;
  overflow-y: auto;
  background-color: #EEF7FE;
}

.dialog-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.user-question {
  align-self: flex-end;
  background-color: #467AF4;
  color: white;
  padding: 10px 15px;
  border-radius: 10px;
  max-width: 80%;
  word-break: break-word;
  margin-left: auto;
}

.bot-answer {
  align-self: flex-start;
  background-color: #ECECEC;
  color: #333;
  padding: 10px 15px;
  border-radius: 10px;
  max-width: 80%;
  word-break: break-word;
  margin-right: auto;
  margin-top: 5px;
}

.dialog-item.active {
  background-color: #EEF7FE;
}

.phone-number-item {
  margin: 5px 0;
}

/* 多行标签支持 */
::v-deep .el-tabs__nav-wrap {
  overflow: visible !important;
}

::v-deep .el-tabs__nav {
  flex-wrap: wrap;
  width: 100%;
  white-space: normal;
}

::v-deep .el-tabs__item {
  margin-bottom: 8px;
  flex-shrink: 0;
}

/* 隐藏原生 active-bar */
::v-deep .el-tabs__active-bar {
  display: none !important;
}

::v-deep .el-tabs__nav {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  white-space: normal;
}

::v-deep .el-tabs__item {
  margin-bottom: 8px;
  flex-shrink: 0;
  /* 平滑过渡 */
  transition: all 0.3s ease;
}

/* 激活状态：用背景 + 底边框代替 active-bar */
::v-deep .el-tabs__item.is-active {
  color: #467AF4;
  font-weight: bold;
  background-color: #e8f3ff;
  border-bottom: 3px solid #467AF4;
  border-radius: 4px 4px 0 0;
}

/* hover 效果 */
::v-deep .el-tabs__item:hover {
  color: #467AF4;
  background-color: #f5f7fa;
}

/* 覆盖 Element UI 对第2个开始的 tab 的 padding 重置 */
::v-deep .el-tabs--top .el-tabs__item.is-top:nth-child(n),
::v-deep .el-tabs--bottom .el-tabs__item.is-top:nth-child(n) {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
</style>
